import { useEffect, useState, type ReactNode } from 'react';
import { initAuth } from './authService';

/**
 * Bootstraps the session (restores tokens from sessionStorage and validates
 * them against the backend) before rendering the app tree.
 * Shows a minimal splash while the check resolves.
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    initAuth().finally(() => {
      if (active) setReady(true);
    });
    return () => {
      active = false;
    };
  }, []);

  if (!ready) {
    return (
      <div className="grid h-screen place-items-center bg-[#eef1ef]">
        <div className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[1px] text-[#8a978f]">
          <span className="h-2.5 w-2.5 animate-pulse rounded-full bg-login" />
          Cargando servicio…
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
